<!--
  Up, down or flat against the trend window, with the change beside it. This replaces CGS's
  angle arrows and the click-to-open "Comparison" tooltip. The trend figure is in the title
  attribute instead, so it shows on hover without a click.

  `lowerIsBetter` only recolours (days on line, turn times). The arrow always shows which way
  the number moved.
-->
<template>
  <span :class="['ins-trend', 'ins-trend--' + t.tone]" :title="tooltip">
    <i v-if="t.dir === 'up'" class="fa-solid fa-caret-up" aria-hidden="true"></i>
    <i v-else-if="t.dir === 'down'" class="fa-solid fa-caret-down" aria-hidden="true"></i>
    <i v-else-if="t.dir === 'flat'" class="fa-solid fa-caret-right" aria-hidden="true"></i>
    <span v-if="showPct && t.pct !== null">{{ pctText }}</span>
    <span v-else-if="showPct && t.dir !== 'none'" class="ins-muted">{{ t.dir === 'flat' ? 'no change' : 'new' }}</span>
    <span class="ins-sr">{{ srText }}</span>
  </span>
</template>

<script>
import { trendOf, formatAs } from '@/helpers/insights/insightMath.js'

export default {
  name: 'TrendDelta',
  props: {
    cur: { type: [Number, String], default: null },
    prev: { type: [Number, String], default: null },
    format: { type: String, default: 'int' },
    lowerIsBetter: { type: Boolean, default: false },
    showPct: { type: Boolean, default: true },
    label: { type: String, default: 'Trend' }
  },
  computed: {
    t() { return trendOf(this.cur, this.prev, { lowerIsBetter: this.lowerIsBetter }) },
    pctText() {
      const p = this.t.pct
      return `${p > 0 ? '+' : ''}${Math.abs(p) >= 100 ? p.toFixed(0) : p.toFixed(1)}%`
    },
    tooltip() { return `${this.label}: ${formatAs(this.prev, this.format)}` },
    srText() {
      if (this.t.dir === 'none') return ''
      return ` (${this.t.dir === 'flat' ? 'unchanged' : this.t.dir} from ${formatAs(this.prev, this.format)})`
    }
  }
}
</script>

<style scoped>
.ins-sr { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }
</style>
